export default __webpack_public_path__ + "static/media/sdwan.4257b7b5.png";